module.exports = __webpack_public_path__ + "img/logo.97da881b.svg";